const checkbox = {
    types: {
        Default: {
            rectangle: {
                color: 'PRIMARY_600',
                hover: 'PRIMARY_600',
            },
            text: {
                color: 'INK_800',
                hover: 'INK_600',
                focus: 'INK_800',
            },
            svg: {
                fill: 'PRIMARY_600',
                hover: 'PRIMARY_500',
                focus: 'PRIMARY_600',
            },
            border: 'INK_300',
            activeBorder: 'PRIMARY_600',
            background: 'SNOW_100',
            activeBackground: 'SNOW_100',
            disabledColor: 'INK_400',
            disabledBorderColor: 'INK_200',
            disabledBackgroundColor: 'SNOW_400',
        },
        Primary: {
            rectangle: {
                color: 'SNOW_100',
                hover: 'SNOW_100',
            },
            text: {
                color: 'INK_800',
                hover: 'INK_600',
                focus: 'INK_800',
            },
            svg: {
                fill: 'SNOW_100',
                hover: 'SNOW_200',
                focus: 'SNOW_100',
            },
            border: 'PRIMARY_600',
            activeBorder: 'PRIMARY_600',
            background: 'SNOW_100',
            activeBackground: 'PRIMARY_600',
            disabledColor: 'INK_400',
            disabledBorderColor: 'PRIMARY_LIGHT',
            disabledBackgroundColor: 'PRIMARY_LIGHTER_20',
        },
        Basic: {
            rectangle: {
                color: 'SNOW_100',
                hover: 'SNOW_100',
            },
            text: {
                color: 'INK_800',
                hover: 'INK_600',
                focus: 'INK_800',
            },
            svg: {
                fill: 'SNOW_100',
                hover: 'SNOW_200',
                focus: 'SNOW_100',
            },
            border: 'INK_500',
            activeBorder: 'INK_500',
            background: 'SNOW_100',
            activeBackground: 'INK_600',
            disabledColor: 'INK_400',
            disabledBorderColor: 'SKY_DARK',
            disabledBackgroundColor: 'INK_A50',
        },
    },
    isError: { color: 'RED_700', border: 'RED_600', background: 'RED_300' },
};
export default checkbox;
//# sourceMappingURL=checkbox.js.map